import { Grid2X2, Grid3X3 } from "lucide-react";

export default function CapsViewToggle({ value, onChange }) {
  const options = [
    {
      value: "standard",
      label: "Standard view",
      icon: Grid2X2,
    },
    {
      value: "compact",
      label: "Compact view",
      icon: Grid3X3,
    },
  ];

  return (
    <div
      className="inline-flex rounded-full border border-border bg-white p-1"
      role="group"
      aria-label="Product grid density"
    >
      {options.map((option) => {
        const Icon = option.icon;
        const active = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onChange(option.value)}
            aria-label={option.label}
            aria-pressed={active}
            className={`flex size-9 items-center justify-center rounded-full transition focus:outline-none focus:ring-2 focus:ring-neutral-950 ${
              active
                ? "bg-neutral-950 text-white"
                : "text-muted-foreground hover:bg-neutral-100"
            }`}
          >
            <Icon className="size-4" />
          </button>
        );
      })}
    </div>
  );
}